module.exports = __webpack_public_path__ + "img/kong5.fb00451f.png";